import { Inject, Injectable } from '@angular/core';
import _ from 'lodash'

@Injectable({
    providedIn: 'root',
})
export class MySynchConstantService {

   additionalHerdData: String = "additionalHerdData";
   outofdateDataExpiries:String = "outofdateDataExpiries";
   outofdateDataNotificationName:String = "OUTOFDATEDATA";
   noMetaDataDateExpiries:String = "noMetaDataDateExpiries";
   noMetaDataDateNotificationName:String = "NOMETADATADATE";
   
   defaultTerritoryManagerDashboardTab:String = "test-farms";

   defaultUserCountry:String = "United States"; // user field needs CodeFile CodeValue
   defaultFarmCountry:String = "UNITEDSTATES";

   defaultDateFormatRegion:String = "usa";
   defaultShortDateFormat:String = "MM-DD-YYYY";
   defaultMediumDateFormat:String = "MMM DD, YYYY";
   defaultLongDateFormat:String = "MMMM DD, YYYY";
   defaultTimeFormat:String = "HH:mm A";
   defaultDateSeparator:String = "/";

   dateFormats = {
         usa: {
            date: 'MM-DD-YYYY',
			dateMedium: 'MMM DD, YYYY',
			dateLong: 'MMMM DD, YYYY'

         },
         aus: {
			date: 'DD-MM-YYYY',
			dateMedium: 'DD MMM YYYY',
			dateLong: 'DD MMMM YYYY'
		},
        canada: {
			date: 'DD-MM-YYYY',
			dateMedium: 'DD MMM YYYY',
			dateLong: 'DD MMMM YYYY'
		},
		international: {
			date: 'YYYY-MM-DD',
			dateMedium: 'DD MMM YYYY',
			dateLong: 'DD MMMM YYYY'
		}
    }

   dairyCompHMSCode:String = "DC305"; 

   specialReportDescriptionsCodeType:String = 'SPCREPORTDESC';
   specialReportsShinyURLPrefix:String = "https://parnell.shinyapps.io/";
   specialReportsAzureStorageContainerName:String = "special-reports";

   shinyServerBaseSubdomain:String = "shinyserver";
   shinyServerBaseDomain:String = "parnell.com";

   heiferDOPTypeCode:string = "HEIFER";
   cowBeforeBreedingDOPTypeCode:string = "COWBEFOREBREED";
   cowAfterBreedingDOPTypeCode:string = "COWAFTERBREED";


    constructor(){

    }
}